module.exports = __webpack_public_path__ + "static/8-0763eef5244645a9f4ccdf34116e1dfd.jpeg";